export const filters = (state: any) => state?.filters;

export const isFiltersActive = (state: any) => state?.filters && Object.values(state.filters)?.find((v) => v);
